/**
 * Renders clock with relative distance
 */
import { useEffect, useState } from 'react';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import Text from '../../atoms/Text';

 interface IClockProps {
  timestamp: number
 }

const UPDATE_INTERVAL = 1000;

const Clock = ({ timestamp }: IClockProps) => {
  const [distance, setDistance] = useState('');

  useEffect(() => {
    setDistance(formatDistanceToNow(timestamp, { includeSeconds: true }));

    const interval = setTimeout(() => {
      setDistance(formatDistanceToNow(timestamp, { includeSeconds: true }));
    }, UPDATE_INTERVAL);

    return () => clearTimeout(interval);
  }, [timestamp]);

  return <Text size={12} className='tableCell clock text--grey-600'>{distance}</Text>;
};

export default Clock;
